import { AdminRole } from "@repo/api-dtos"
import { createFileRoute } from "@tanstack/react-router"
import { PageHeader } from "@/components/layout"
import { ReleaseBatchPanel } from "@/features/referrals-admin/ReleaseBatchPanel"
import { useAdminRoles } from "@/hooks/use-admin-roles"

export const Route = createFileRoute("/referrals/batches")({
	component: ReferralBatchesPage,
})

function ReferralBatchesPage() {
	const { hasRole } = useAdminRoles()
	const canReview = hasRole(AdminRole.MarketplaceCoupons)
	const canRelease = hasRole(AdminRole.Superadmin)
	const canSuspend = hasRole(AdminRole.MarketplaceUserManagement)

	return (
		<div className="flex max-w-5xl flex-col gap-6 p-6">
			<PageHeader
				title="Release batches"
				description="Rewards are paid once a week. Review a slot's rewards here: open a referral, disqualify it or suspend its referrer, then mark the batch reviewed. The hourly tick pays a reviewed batch once its slot has passed, including one reviewed late; an overdue batch with rewards opens first. A suspended referrer's rewards wait for the next slot."
			/>
			<ReleaseBatchPanel
				canReview={canReview}
				canRelease={canRelease}
				canSuspend={canSuspend}
			/>
		</div>
	)
}
